/* ============================================================
   Armeria Lorenzi 1940 — comportamenti del tema
   1. Scheda prodotto: la descrizione viene divisa in schede e
      le specifiche tecniche diventano una tabella.
   2. Rivelazione al primo scorrimento.
   3. Torna su.
   ============================================================ */
(function () {
  'use strict';

  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var NBSP = / /g;
  var SPLIT = '|@br@|';

  /* --------------------------------------------------------
     1. Descrizione prodotto -> schede + tabella specifiche
     -------------------------------------------------------- */

  // Intestazioni riconosciute dentro le descrizioni del catalogo.
  var HEADINGS = [
    { re: /^caratteristiche\s+principali$/i,   tab: 'Caratteristiche', kind: 'list' },
    { re: /^specifiche\s+tecniche$/i,          tab: 'Scheda tecnica',  kind: 'spec' },
    { re: /^contenuto\s+della\s+confezione$/i, tab: 'Confezione',      kind: 'list' },
    { re: /^nota\s+importante$/i,              tab: 'Note',            kind: 'text' },
    { re: /^nota$/i,                           tab: 'Note',            kind: 'text' }
  ];

  function clean(s) {
    return (s || '').replace(NBSP, ' ').replace(/\s+/g, ' ').trim().replace(/[:.]$/, '');
  }

  function matchHeading(node) {
    if (!node || node.nodeType !== 1) return null;
    if (!/^(P|H2|H3|H4|STRONG|DIV)$/.test(node.tagName)) return null;
    var txt = clean(node.textContent);
    if (!txt || txt.length > 60) return null;
    for (var i = 0; i < HEADINGS.length; i++) {
      if (HEADINGS[i].re.test(txt)) return HEADINGS[i];
    }
    return null;
  }

  // "Marca: Okuma" -> ['Marca', 'Okuma']. null se non e' una coppia.
  function splitPair(text) {
    var t = (text || '').replace(NBSP, ' ').trim();
    var i = t.indexOf(':');
    if (i < 1) return null;
    var k = t.slice(0, i).trim();
    var v = t.slice(i + 1).trim();
    if (!k || !v || k.length > 46) return null;
    // una chiave di specifica non contiene punteggiatura di frase
    if (/[.!?;]/.test(k)) return null;
    return [k, v];
  }

  // Estrae righe di testo da un insieme di nodi, spezzando su <br> e <li>.
  function textLines(nodes) {
    var out = [];
    nodes.forEach(function (n) {
      if (n.nodeType !== 1) {
        var t = clean(n.textContent);
        if (t) out.push(t);
        return;
      }
      if (n.tagName === 'UL' || n.tagName === 'OL') {
        Array.prototype.forEach.call(n.children, function (li) {
          var nested = li.querySelector('ul, ol');
          if (nested) {
            var head = li.cloneNode(true);
            var rm = head.querySelector('ul, ol');
            if (rm) rm.parentNode.removeChild(rm);
            var ht = clean(head.textContent);
            if (ht) out.push(ht);
            Array.prototype.forEach.call(nested.children, function (sub) {
              var st = clean(sub.textContent);
              if (st) out.push(st);
            });
          } else {
            var lt = clean(li.textContent);
            if (lt) out.push(lt);
          }
        });
        return;
      }
      var html = n.innerHTML || '';
      if (/<br\s*\/?>/i.test(html)) {
        var tmp = document.createElement('div');
        tmp.innerHTML = html.replace(/<br\s*\/?>/gi, SPLIT);
        tmp.textContent.split(SPLIT).forEach(function (piece) {
          var p = clean(piece);
          if (p) out.push(p);
        });
      } else {
        var pt = clean(n.textContent);
        if (pt) out.push(pt);
      }
    });
    return out;
  }

  function buildSpecTable(nodes) {
    var rows = [];
    var leftovers = [];
    textLines(nodes).forEach(function (line) {
      var pair = splitPair(line);
      if (pair) rows.push(pair);
      else if (line) leftovers.push(line);
    });
    if (rows.length < 3) return null; // troppo poche: non vale una tabella

    var wrap = document.createElement('div');
    var table = document.createElement('table');
    table.className = 'al-spec';
    var tbody = document.createElement('tbody');
    rows.forEach(function (r) {
      var tr = document.createElement('tr');
      var th = document.createElement('th');
      th.textContent = r[0];
      var td = document.createElement('td');
      td.textContent = r[1];
      tr.appendChild(th);
      tr.appendChild(td);
      tbody.appendChild(tr);
    });
    table.appendChild(tbody);
    wrap.appendChild(table);

    leftovers.forEach(function (line) {
      if (line.length < 12) return;
      var p = document.createElement('p');
      p.className = 'al-spec__note';
      p.textContent = line;
      wrap.appendChild(p);
    });
    return wrap;
  }

  function slug(s, uid) {
    return 'al-tab-' + uid + '-' + s.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
  }

  function buildTabs(root) {
    if (!root || root.dataset.alTabs === 'done') return;

    var kids = Array.prototype.slice.call(root.childNodes).filter(function (n) {
      return n.nodeType === 1 || (n.nodeType === 3 && n.textContent.trim());
    });
    if (!kids.length) return;

    var sections = [{ tab: 'Descrizione', kind: 'text', nodes: [] }];
    kids.forEach(function (n) {
      var h = matchHeading(n);
      if (h) sections.push({ tab: h.tab, kind: h.kind, nodes: [] });
      else sections[sections.length - 1].nodes.push(n);
    });

    // unisce sezioni con lo stesso nome (es. due blocchi "Nota")
    var merged = [];
    sections.forEach(function (s) {
      if (!s.nodes.length) return;
      var found = null;
      for (var i = 0; i < merged.length; i++) {
        if (merged[i].tab === s.tab) found = merged[i];
      }
      if (found) found.nodes = found.nodes.concat(s.nodes);
      else merged.push(s);
    });
    if (merged.length < 2) return; // niente da separare: si lascia com'e'

    var uid = Math.random().toString(36).slice(2, 7);
    var wrap = document.createElement('div');
    wrap.className = 'al-tabs';
    var nav = document.createElement('div');
    nav.className = 'al-tabs__nav';
    nav.setAttribute('role', 'tablist');
    wrap.appendChild(nav);

    merged.forEach(function (s, i) {
      var id = slug(s.tab, uid);

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'al-tabs__btn';
      btn.textContent = s.tab;
      btn.id = id + '-btn';
      btn.setAttribute('role', 'tab');
      btn.setAttribute('aria-controls', id);
      btn.setAttribute('aria-selected', i === 0 ? 'true' : 'false');
      btn.tabIndex = i === 0 ? 0 : -1;
      nav.appendChild(btn);

      var panel = document.createElement('div');
      panel.className = 'al-tabs__panel';
      panel.id = id;
      panel.setAttribute('role', 'tabpanel');
      panel.setAttribute('aria-labelledby', id + '-btn');
      if (i !== 0) panel.hidden = true;

      var content = null;
      if (s.kind === 'spec') content = buildSpecTable(s.nodes);
      if (!content) {
        content = document.createElement('div');
        s.nodes.forEach(function (n) { content.appendChild(n.cloneNode(true)); });
      }
      panel.appendChild(content);
      wrap.appendChild(panel);
    });

    function select(idx) {
      var btns = nav.querySelectorAll('.al-tabs__btn');
      var panels = wrap.querySelectorAll('.al-tabs__panel');
      for (var i = 0; i < btns.length; i++) {
        var on = i === idx;
        btns[i].setAttribute('aria-selected', on ? 'true' : 'false');
        btns[i].tabIndex = on ? 0 : -1;
        panels[i].hidden = !on;
      }
    }

    nav.addEventListener('click', function (e) {
      var b = e.target.closest ? e.target.closest('.al-tabs__btn') : null;
      if (!b) return;
      select(Array.prototype.indexOf.call(nav.children, b));
    });

    nav.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
      var btns = Array.prototype.slice.call(nav.children);
      var cur = 0;
      for (var i = 0; i < btns.length; i++) {
        if (btns[i].getAttribute('aria-selected') === 'true') cur = i;
      }
      var next = e.key === 'ArrowRight'
        ? (cur + 1) % btns.length
        : (cur - 1 + btns.length) % btns.length;
      select(next);
      btns[next].focus();
      e.preventDefault();
    });

    root.textContent = '';
    root.appendChild(wrap);
    root.dataset.alTabs = 'done';
  }

  function initTabs(scope) {
    var els = (scope || document).querySelectorAll('.product__description');
    Array.prototype.forEach.call(els, function (el) {
      try { buildTabs(el); } catch (err) { /* la descrizione resta com'e' */ }
    });
  }

  /* --------------------------------------------------------
     1b. I dettagli vanno sotto, a tutta larghezza
     La colonna d'acquisto resterebbe altrimenti lunghissima
     con mezza pagina vuota accanto alla galleria.
     -------------------------------------------------------- */

  function relocateDescription() {
    var prod = document.querySelector('.product');
    if (!prod) return;
    var desc = prod.querySelector('.product__description');
    if (!desc || desc.dataset.alMoved === '1') return;

    var host = document.createElement('div');
    host.className = 'al-details page-width';
    desc.dataset.alMoved = '1';
    host.appendChild(desc);

    var section = prod.closest ? prod.closest('.shopify-section') : null;
    (section || prod.parentNode).appendChild(host);
  }

  /* --------------------------------------------------------
     1c. Niente ingrandimenti: le foto restano nitide
     Molte foto del catalogo sono piccole (225-600 px) mentre il
     riquadro della scheda arriva a ~700. Ingrandirle le sgrana.
     Qui ogni foto non viene mai mostrata piu' grande del suo
     originale (con un margine del 15%, impercettibile).
     -------------------------------------------------------- */

  var MARGINE = 1.15;

  function limitaIngrandimento(img) {
    if (!img || img.dataset.alLimitata === '1') return;
    if (!img.naturalWidth) return;

    var massima = Math.round(img.naturalWidth * MARGINE);
    var riquadro = img.parentElement;
    if (!riquadro) return;

    var largRiquadro = riquadro.getBoundingClientRect().width;
    if (!largRiquadro || massima >= largRiquadro) {
      img.dataset.alLimitata = '1';
      return;
    }

    img.style.maxWidth = massima + 'px';
    img.style.margin = '0 auto';
    riquadro.classList.add('al-foto-piccola');
    img.dataset.alLimitata = '1';
  }

  function initFoto(scope) {
    var sel = '.product__media img, .product-media-container img, .al-hero__media img';
    var imgs = (scope || document).querySelectorAll(sel);
    Array.prototype.forEach.call(imgs, function (img) {
      if (img.closest && img.closest('.al-hero__media')) return; // l'apertura si ritaglia, non si contiene
      if (img.complete) limitaIngrandimento(img);
      else img.addEventListener('load', function () { limitaIngrandimento(img); }, { once: true });
    });
  }

  /* --------------------------------------------------------
     2. Rivelazione al primo scorrimento
     -------------------------------------------------------- */

  function initReveal(scope) {
    var items = (scope || document).querySelectorAll('.al-in:not(.is-in)');
    if (!items.length) return;

    if (REDUCED || !('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(items, function (el) { el.classList.add('is-in'); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-in');
        io.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });

    Array.prototype.forEach.call(items, function (el, i) {
      if (!el.style.getPropertyValue('--al-d')) {
        var pos = el.parentElement
          ? Array.prototype.indexOf.call(el.parentElement.children, el)
          : i;
        el.style.setProperty('--al-d', Math.min(pos, 7) * 55 + 'ms');
      }
      io.observe(el);
    });
  }

  /* --------------------------------------------------------
     2b. I numeri si contano da soli quando entrano in pagina
     Solo valori davvero numerici: numeri di telefono e parole
     restano come sono.
     -------------------------------------------------------- */

  function initConteggi(scope) {
    var nodi = (scope || document).querySelectorAll('.al-hero__stat b, [data-conta]');
    if (!nodi.length) return;

    var candidati = [];
    Array.prototype.forEach.call(nodi, function (el) {
      if (el.dataset.contaFatto) return;
      var testo = el.textContent.trim();
      // numero eventualmente seguito da un simbolo: 1940, 237, "55 €", "30%"
      var m = testo.match(/^(\d{1,6})(?:[.,](\d{1,2}))?\s*([€%+]?)$/);
      if (!m) return;
      var valore = parseInt(m[1], 10);
      if (isNaN(valore) || valore < 3) return;
      el.dataset.contaFatto = '1';
      candidati.push({ el: el, valore: valore, coda: m[3] ? ' ' + m[3] : '', testo: testo });
    });
    if (!candidati.length) return;

    if (REDUCED || !('IntersectionObserver' in window)) return;

    function anima(c) {
      var durata = 900;
      var inizio = null;
      c.el.textContent = '0' + c.coda;
      function passo(t) {
        if (inizio === null) inizio = t;
        var q = Math.min((t - inizio) / durata, 1);
        // decelerazione morbida
        var e = 1 - Math.pow(1 - q, 3);
        c.el.textContent = Math.round(c.valore * e) + c.coda;
        if (q < 1) requestAnimationFrame(passo);
        else c.el.textContent = c.testo;
      }
      requestAnimationFrame(passo);
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var c = candidati.filter(function (x) { return x.el === entry.target; })[0];
        if (c) anima(c);
        io.unobserve(entry.target);
      });
    }, { threshold: 0.5 });

    candidati.forEach(function (c) { io.observe(c.el); });
  }

  /* --------------------------------------------------------
     3. Torna su
     -------------------------------------------------------- */

  function initTop() {
    if (document.querySelector('.al-top')) return;
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'al-top';
    btn.setAttribute('aria-label', 'Torna in cima alla pagina');
    btn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M12 19V5M5 12l7-7 7 7"/></svg>';
    btn.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: REDUCED ? 'auto' : 'smooth' });
    });
    document.body.appendChild(btn);

    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        btn.classList.toggle('is-on', window.scrollY > 700);
        ticking = false;
      });
    }, { passive: true });
  }

  /* -------------------------------------------------------- */

  function boot() {
    initTabs();
    relocateDescription();
    initReveal();
    initConteggi();
    initTop();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  // l'editor del tema ricarica le sezioni: si rigenera quello che serve
  document.addEventListener('shopify:section:load', function (e) {
    initTabs(e.target);
    relocateDescription();
    initReveal(e.target);
    initConteggi(e.target);
  });

})();
